import {AllActivityTypes, AllActivityTypesArray} from "../../../types-enums/activity";
import {activityHasReturnOption} from "../../../utils/check/activities";

export enum RETURN_ACTIVITY_UPDATE_STATE {
    ORIGINAL_HAS_RETURN_AND_UPDATED_ACTIVITY_HAS_NO_RETURN,
    ORIGINAL_HAS_NO_RETURN_AND_UPDATED_ACTIVITY_HAS_RETURN,
    ORIGINAL_HAS_RETURN_AND_UPDATED_ACTIVITY_HAS_RETURN,
    ORIGINAL_HAS_NO_RETURN_AND_UPDATED_ACTIVITY_HAS_NO_RETURN
}

export const getStateOfReturnActivity = (
    activity: AllActivityTypes,
    activities: AllActivityTypesArray,
    whichState: RETURN_ACTIVITY_UPDATE_STATE,
    idOfActivityToUpdate: string | undefined
) => {
    if (typeof idOfActivityToUpdate !== 'undefined') {
        const activityIndexToUpdate = activities.map(activity => activity.common.id).indexOf(idOfActivityToUpdate)
        const originalActivity = activities[activityIndexToUpdate]
        if (activityIndexToUpdate > -1) {
            switch (whichState) {
                case RETURN_ACTIVITY_UPDATE_STATE.ORIGINAL_HAS_RETURN_AND_UPDATED_ACTIVITY_HAS_RETURN:
                    return activityHasReturnOption(originalActivity) &&
                        originalActivity.returnId !== null &&
                        activityHasReturnOption(activity) &&
                        activity.returnId !== null
                case RETURN_ACTIVITY_UPDATE_STATE.ORIGINAL_HAS_RETURN_AND_UPDATED_ACTIVITY_HAS_NO_RETURN:
                    return activityHasReturnOption(originalActivity) &&
                        originalActivity.returnId !== null &&
                        activityHasReturnOption(activity) &&
                        activity.returnId === null
                case RETURN_ACTIVITY_UPDATE_STATE.ORIGINAL_HAS_NO_RETURN_AND_UPDATED_ACTIVITY_HAS_RETURN:
                    return activityHasReturnOption(originalActivity) &&
                        originalActivity.returnId === null &&
                        activityHasReturnOption(activity) &&
                        activity.returnId !== null
                case RETURN_ACTIVITY_UPDATE_STATE.ORIGINAL_HAS_NO_RETURN_AND_UPDATED_ACTIVITY_HAS_NO_RETURN:
                    return activityHasReturnOption(originalActivity) &&
                        originalActivity.returnId === null &&
                        activityHasReturnOption(activity) &&
                        activity.returnId === null
                default:
                    whichState satisfies never
            }
        }
    }
    return false
}